import { TypedTable } from "@/components/ui/table/TypedTable";
import { useNavigate, type NavigateFunction } from "react-router";
import { useMemo } from "react";
import { createColumnHelper, tableFeatures } from "@tanstack/react-table";
import { Loading, QueryError } from "@/components/Loading/Loading";
import { getPedidosFiltrados, usePedidosVenta, type Pedido } from "./EmpaquetadoPedidos";
import { CommonFeatures } from "@/hooks/useTanstackTable";


interface TablaPedidosProps {
	readonly filtroCiclo: string;
	readonly filtroMedio: string;
	readonly filtroPedido: string;
}
export function TablaPedidos(props: TablaPedidosProps) {
	const navigate = useNavigate();

	const { data, isPending, error } = usePedidosVenta();
	const { columns, features } = useMemo(() => Columns(navigate), [navigate]);

	const pedidosFiltrados = useMemo(() => {
		return getPedidosFiltrados(props.filtroCiclo, props.filtroMedio, props.filtroPedido, data ?? {});
	}, [props.filtroCiclo, props.filtroMedio, props.filtroPedido, data]);



	if (error) return <QueryError error={error} fallback="Error al cargar los pedidos" />;
	if (isPending) return <Loading />;




	return (
		<TypedTable
			className="dataTable display"
			features={features}
			columns={columns}
			data={pedidosFiltrados}

			noResultsMessage="No se encontraron pedidos"
			errorMessage="Error al cargar los pedidos"
			isLoading={false}
			isError={false}
		/>
	);
}

function Columns(navigate: NavigateFunction) {
	const columnHelper = createColumnHelper<typeof features, Pedido>();
	const features = tableFeatures(CommonFeatures);

	function getCeldaPedido(linea: Pedido) {
		const dateFormatter = new Intl.DateTimeFormat("es-ES", {
			year: "numeric",
			month: "2-digit",
			day: "2-digit",
		});
		return (
			<div>
				{linea.idPedido}
				<br />
				{dateFormatter.format(new Date(linea.timestampPedido * 1000))}
			</div>
		);
	}
	function getBtnAccion(linea: Pedido) {
		const onClick = () => {
			const params = new URLSearchParams({
				"idPedido": String(linea.idPedido),
			});
			void navigate(`/empaquetado?${params.toString()}`);
		};

		return (
			<button type="button" className="tableButton" onClick={onClick}>
				<i className="fa fa-boxes-packing" />
			</button>
		);
	}

	const columns = columnHelper.columns([
		columnHelper.display({
			id: "pedido",
			header: "Pedido",
			meta: { className: "dt-center" },
			cell: info => getCeldaPedido(info.row.original),
		}),
		columnHelper.accessor("nombreCliente", { header: "Cliente" }),
		columnHelper.display({
			id: "accion",
			header: "Acción",
			meta: { className: "dt-center p-0" },
			cell: info => getBtnAccion(info.row.original),
		}),
	]);
	return { columns, features };
}